// extracted by mini-css-extract-plugin
export default {"wrapper":"_469e91ef","buttonWrapper":"_e14a7ff9"};